import Vue from 'vue';
import Router from 'vue-router';

import db from '@/db';

import Home from './views/Home.vue';
import Onboarding from './views/Onboarding.vue';
import Overview from './views/Overview.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      async beforeEnter(to, from, next) {
        const user = await db.user.get('user');
        if (user && user.onboardingComplete) next();
        else next({ path: '/onboarding', query: { step: 0 } });
      },
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: Onboarding,
      async beforeEnter(to, from, next) {
        const user = await db.user.get('user');
        if (user && user.onboardingComplete) next('/');
        else next();
      },
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview,
      async beforeEnter(to, from, next) {
        const user = await db.user.get('user');
        if (user && user.onboardingComplete) next();
        else next({ path: '/onboarding', query: { step: 0 } });
      },
    },
    {
      path: '*',
      beforeEnter(to, from, next) {
        next({ path: '/', query: { error: 404 } });
      },
    },
  ],
});
